document.addEventListener( 'DOMContentLoaded', () => {
  // === Viewport-Based Play/Stop ===
  const handleIntersection = ( entries ) => {
    entries.forEach( entry => {
      const player = entry.target;
      if ( entry.isIntersecting ) {
        player.play();
      }
    } );
  };

  const observer = new IntersectionObserver( handleIntersection, { threshold: 0.4 } );

  const initViewportLottie = () => {
    document.querySelectorAll( 'lottie-player' ).forEach( player => {
    // Skip players inside inactive swiper slides
      const slide = player.closest( '.swiper-slide' );
      const accordion = player.closest( '.e-acc__flt-itm-wrpr' );
      if ( slide && !slide.classList.contains( 'swiper-slide-active' ) || accordion ) {
        return;
      }

      lazyLottiePlayer( player );

      observer.observe( player );
    } );
  };


  const handleSlideChange = ( swiperEl ) => {
    const allSlides = swiperEl.querySelectorAll( '.swiper-slide' );

    allSlides.forEach( slide => {
      slide.querySelectorAll( 'lottie-player' ).forEach( player => {
        observer.unobserve( player ); // Stop observing old ones
        player.stop?.();
        player.seek?.( 0 );
      } );
    } );

    const activeSlide = swiperEl.querySelector( '.swiper-slide-active' );
    if ( !activeSlide ) return;

    activeSlide.querySelectorAll( 'lottie-player' ).forEach( player => {
      observer.observe( player ); // Re-observe active slide's lotties
      if ( player.isReady ) {
        player.play();
      } else {
        player.addEventListener( 'ready', () => {
          player.play();
        }, { once: true } );
      }
    } );
  };

  const restartLottie = ( player ) => {
    // Check if the player is already playing
    if ( player.isPlaying ) return;
    
    player.stop();
    setTimeout( () => player.play(), 50 ); // Small delay ensures it restarts cleanly
  };

  const handleHeroBannerLottie = () => {
    const heroBanners = document.querySelectorAll( '.e-stn--hero-banner' );
    
    if ( heroBanners.length === 0 ) return;
    
    const heroObserver = new IntersectionObserver( ( entries ) => {
      entries.forEach( entry => {
        const heroBanner = entry.target;
        const lottiePlayer = heroBanner.querySelector( 'lottie-player' );
        
        if ( entry.isIntersecting && lottiePlayer ) {
          // Start the animation when 10% of the hero banner is visible
          if ( lottiePlayer.isReady ) {
            setTimeout( () => lottiePlayer.play(), 1000 );
          } else {
            lottiePlayer.addEventListener( 'ready', () => {
              setTimeout( () => lottiePlayer.play(), 1000 );
            }, { once: true } );
          }
          
          // Unobserve after starting the animation
          heroObserver.unobserve( heroBanner );
        }
      } );
    }, { threshold: 0.3 } );
    
    // Observe all hero banners
    heroBanners.forEach( banner => {
      heroObserver.observe( banner );
    } );
  };

  const bindSwiperEvents = ( swiperEl ) => {
    if ( swiperEl.swiper ) {
      swiperEl.swiper.on( 'slideChangeTransitionEnd', () => handleSlideChange( swiperEl ) );
    } else {
      const waitForSwiper = setInterval( () => {
        if ( swiperEl.swiper ) {
          clearInterval( waitForSwiper );
          swiperEl.swiper.on( 'slideChangeTransitionEnd', () => handleSlideChange( swiperEl ) );
        }
      }, 200 );
    }
  };

  const initSwiperLottieHandlers = () => {
    const allContentSwipers = document.querySelectorAll( '.e-stn--pill-tabs .e-tbs__content.swiper' );
    allContentSwipers.forEach( bindSwiperEvents );
  };
 
  
  const initAccordionFloatLottie = () => {
    const allAccordions = document.querySelectorAll( '.e-acc' );

    const accordionViewportObserver = createAccordionViewportObserver( allAccordions );
    const mutationObserver = createActivePanelObserver();

    allAccordions.forEach( acc => {
      accordionViewportObserver.observe( acc );

      acc.querySelectorAll( '.e-acc__flt-itm-wrpr' ).forEach( panel => {
        // Initialize the wasActive state
        panel.dataset.wasActive = panel.classList.contains( 'active' ).toString();
        
        setupLottieReadyReset( panel );
        mutationObserver.observe( panel, {
          attributes: true,
          attributeFilter: ['class']
        } );
      } );
    } );
  };

  // === Extracted: Play only current center-most, stop others ===
  function handleAccordionInView( acc, allAccordions ) {
    const activePanel = acc.querySelector( '.e-acc__flt-itm-wrpr.active' );
    const player = activePanel?.querySelector( 'lottie-player' );
    if ( player ) player.play();

    allAccordions.forEach( otherAcc => {
      if ( otherAcc !== acc ) {
        const otherPlayer = otherAcc.querySelector( '.e-acc__flt-itm-wrpr.active lottie-player' );
        if ( otherPlayer ) {
          otherPlayer.stop();
          otherPlayer.seek( 0 );
        }
      }
    } );
  }

  const getRootMargin = () => ( window.innerWidth > 2500 ? '-35% 0px -65%' : '-50% 0px -50%' );
  const observerOptions = {
    root: null,
    rootMargin: getRootMargin(),
    threshold: 0
  };

  function createAccordionViewportObserver( allAccordions ) {
    return new IntersectionObserver( ( entries ) => {
      entries.forEach( entry => {
        const acc = entry.target;
        acc._inViewport = entry.isIntersecting;
        
        if ( entry.isIntersecting ) {
          handleAccordionInView( acc, allAccordions );
        }
      } );
    }, observerOptions );
  }

  // === Extracted: Observe and react to accordion panel becoming active ===
  function createActivePanelObserver() {
    return new MutationObserver( ( mutations ) => {
      mutations.forEach( mutation => {
        const panel = mutation.target;
        const acc = panel.closest( '.e-acc' );
        const player = panel.querySelector( 'lottie-player' );
        if ( !acc || !player ) return;

        // Check if the panel was already active before the mutation
        const wasAlreadyActive = panel.dataset.wasActive === 'true';
        
        if ( panel.classList.contains( 'active' ) && !wasAlreadyActive ) {
          if ( acc._inViewport ) {
            restartLottie( player );
          } else {
            waitUntilInView( panel, player );
          }
        }
        
        // Update the stored state
        panel.dataset.wasActive = panel.classList.contains( 'active' ).toString();
      } );
    } );
  }

  // === Extracted: Wait until panel is in view to trigger animation ===
  function waitUntilInView( panel, player ) {
    panel._panelObserver?.disconnect();

    panel._panelObserver = new IntersectionObserver( ( entries, obs ) => {
      entries.forEach( entry => {
        if ( entry.isIntersecting ) {
          restartLottie( player );
          obs.disconnect();
        }
      } );
    }, { threshold: 0.5 } );

    panel._panelObserver.observe( panel );
  }

  // === Extracted: Reset player on ready ===
  function setupLottieReadyReset( panel ) {
    const player = panel.querySelector( 'lottie-player' );
    if ( !player ) return;

    player.addEventListener( 'ready', () => {
      player.stop();
      player.seek( 0 );
    }, { once: true } );
  }


  function lottieFloatPanelAccordion() {
  // Modify the "destroy" method of the LottiePlayer custom element
  // to prevent lottie players within Accordion floating panels getting auto removed
  // when the panels getting re-attached
    customElements.whenDefined( 'lottie-player' ).then( () => {
      const proto = customElements.get( 'lottie-player' ).prototype;
      const originalDestroy = proto.disconnectedCallback;
      proto.destroy = function ( ...args ) {
      // skip destroy the element is within a floating panel
        if ( this.closest( '.e-acc__flt-itm-wrpr' ) ) {
        // eslint-disable-next-line max-len
        // Reverse effects of https://github.com/LottieFiles/lottie-player/blob/c0b4f8da14b6d31a4dea47581077c9da4d758787/src/lottie-player.ts#L526
          this.firstUpdated();
          // eslint-disable-next-line max-len
          // reverse https://github.com/LottieFiles/lottie-player/blob/c0b4f8da14b6d31a4dea47581077c9da4d758787/src/lottie-player.ts#L538
          document.addEventListener( 'visibilitychange', this._onVisibilityChange );
          return;
        }

        // Call original destroy method
        originalDestroy.apply( this, args );
      };
    } );
  }

  const isMobile = window.matchMedia( '(max-width: 768px)' ).matches;
  function lazyLottiePlayer( player ) {
    if ( !player || player?._lottie?.isLoaded ) return;
    const isMobilePlayer = player.classList.contains( 'lazy-mobile' );
    const isDesktopPlayer = player.classList.contains( 'lazy-desktop' );

    const shouldLoadPlayer =
        ( isMobile && isMobilePlayer ) ||
        ( !isMobile && isDesktopPlayer );

    if ( shouldLoadPlayer ) {
      player.setAttribute( 'src', player.dataset.src );
      player.load( player.src );
    }
  }


  // === Init All ===
  lottieFloatPanelAccordion();
  initViewportLottie();
  initSwiperLottieHandlers();
  initAccordionFloatLottie();
  handleHeroBannerLottie();
} );
